import css from './footer.scss'
import facebook from '../../assets/images/facebook.svg'
import instagram from '../../assets/images/instagram.svg'
import linkedin from '../../assets/images/linkedin.svg'

const Footer = () => {
    return (
        <footer className={css.root}>
            <div className={`container ${css.container}`}>
                <div className={css.container__languageSelector}>
                    <span id="UA" className={css.langSelector}>UA</span>
                    <span id="RU" className={`${css.langSelector} ${css.langSelector_active}`}>RU</span>
                    <span id="EN" className={css.langSelector}>EN</span>
                </div>
                <div className={css.container__title}>Victoria`s Medical Network, 2021 </div>
                <div className={css.container__socialContainer}>
                    <a href="https://www.facebook.com/VictoriasMedical" target="_blank" rel="noopener noreferrer"
                        className={css.container__socialLink}>
                        <img src={facebook}
                            alt="facebook" />
                    </a>
                    <a href="https://www.instagram.com/victoriasmedical.ai" target="_blank"
                        rel="noopener noreferrer" className={css.container__socialLink}>
                        <img src={instagram}
                            alt="instagram" />
                    </a>
                    <a href="https://www.linkedin.com/organization-guest/company/victoriasmedical" target="_blank"
                        rel="noopener noreferrer" className={css.container__socialLink}>
                        <img src={linkedin}
                            alt="linkedin" />
                    </a>
                </div>
                <div className={`${css.container__title} ${css.container__titleMobile}`}>Victoria`s Medical
                Network,
                2021
            </div>
            </div>
        </footer>

    )
}

export default Footer;